<template>
  <div>
    <Header/>
    <ImpRemember/>
    <Tips/>
  </div>
</template>

<script>
    import Header from "./Header";
    import ImpRemember from "./ImpRemember";
    import Tips from "./Tips";
    export default {
      name: "Main",
      components: {Tips, ImpRemember, Header},
      created() {
        this.$store.commit("SET_PAGE_TYPE", "alex-curate");
        this.$store.commit("SET_PAGE_FOOTER_BACKGROUND_COLOR", "#F7F7F7");
        // console.log("Background Color", this.$store.state.pageFooterBackgroundColor);
      }
    }
</script>

<style scoped>

</style>
